import { getSellerPublicEmail } from "common";
import React from "react";
import { Seller } from "types";

export const ReceiptFooterDetails = ({
    seller,
    shortCodes,
    showWiderFormat,
}: {
    seller: Seller;
    shortCodes: string[];
    showWiderFormat: boolean;
}) => {
    const email = getSellerPublicEmail(seller);

    if (showWiderFormat) {
        return (
            <>
                <tr style={{ fontSize: 16 }}>
                    <td
                        colSpan={3}
                        style={{
                            textAlign: "left",
                            paddingTop: 4,
                            paddingBottom: 6,
                        }}
                    >
                        <span style={{ lineHeight: "1.6" }}>
                            If you have any questions please contact us at <var data-var="email">{email}</var> or{" "}
                            <var data-var="phone">{seller.phone}</var>
                        </span>
                    </td>
                </tr>

                <tr style={{ fontSize: 16 }}>
                    <td style={{ width: "50%" }}>
                        {shortCodes.length > 0 ? (
                            <span>
                                Reference #: <var data-var="reference">{shortCodes.join(", ")}</var>
                            </span>
                        ) : null}
                    </td>
                    <td colSpan={2} style={{ paddingLeft: "140px" }}>
                        Powered by Xola
                    </td>
                </tr>
            </>
        );
    }

    return (
        <>
            <tr style={{ fontSize: 10 }}>
                <td colSpan={1}>
                    {shortCodes.length > 0 ? (
                        <span>
                            Reference #: <var data-var="reference">{shortCodes.join(", ")}</var>
                        </span>
                    ) : null}
                </td>

                <td colSpan={2} style={{ textAlign: "right" }}>
                    Powered by Xola
                </td>
            </tr>

            <tr style={{ fontSize: 10, textAlign: "center" }}>
                <td colSpan={3} style={{ padding: "30px" }}>
                    <span>
                        If you have any questions please contact us at {email} or {seller.phone}
                    </span>
                </td>
            </tr>
        </>
    );
};
